// extracted by mini-css-extract-plugin
export default {"box":"merch_box__zkJkY","card":"merch_card__EmiBC","heightfix":"merch_heightfix__uNdWA"};